import React, { useContext, useEffect, useState } from "react";
import "../../../assets/css/user/topShops/TopShops.css";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import TPshop from "../../../components/user/tpshop/Tpshop";
import AppContext from "../../../context/AppContext";
import axios from "axios";

const shops = [
  {
    id: 1,
    name: "Zen Spa Lahore",
    initial: "Z",
    category: "Beauty & Spa",
    rating: 4.8,
    deals: 12,
    city: "Lahore",
    verified: true,
  },
  {
    id: 2,
    name: "AutoCare Pro",
    initial: "A",
    category: "Auto & Home",
    rating: 4.5,
    deals: 8,
    city: "Islamabad",
    verified: true,
  },
  {
    id: 3,
    name: "Royal Kitchen",
    initial: "R",
    category: "Food & Drink",
    rating: 4.9,
    deals: 15,
    city: "Karachi",
    verified: true,
  },
];
// const VerifiedIcon = () => (
//   <svg
//     className="verified-icon"
//     viewBox="0 0 20 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M10 1.5L12.39 6.26L17.5 7.27L13.75 10.92L14.78 16L10 13.77L5.22 16L6.25 10.92L2.5 7.27L7.61 6.26L10 1.5Z"
//       stroke="#3ecf8e"
//       strokeWidth="1.5"
//       strokeLinejoin="round"
//       fill="none"
//     />
//     <path
//       d="M7 10L9 12L13 8"
//       stroke="#3ecf8e"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// const ShopCard = ({ shop }) => (
//   <div className={`shop-card ${shop.featured ? "shop-card--featured" : ""}`}>
//     <div className="shop-avatar">{shop.initial}</div>
//     <div className="shop-info">
//       <div className="shop-name-row">
//         <span className={`shop-name ${shop.featured ? "shop-name--blue" : ""}`}>
//           {shop.name}
//         </span>
//         <VerifiedIcon />
//       </div>
//       <span className="shop-meta">
//         {shop.category} · {shop.city}
//       </span>
//       <div className="shop-stats">
//         <span className="star">★</span>
//         <span className="shop-rating">{shop.rating}</span>
//         <span className="shop-deals">{shop.deals} deals</span>
//       </div>
//     </div>
//   </div>
// );

const TopShops = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);

const [shops, setShops] = useState([]);
const [loading, setLoading] = useState(false);
const fetchTopShops = () => {
  setLoading(true);
     const formData = new FormData();
    formData.append("limit", 3);

  axios
    .post(`${baseUrl}/customer/shop/fetchTopShops`, formData, {
        headers: { "Content-Type": "multipart/formData" },
      })
    .then((res) => {
      console.log(res.data);

      if (res.data.success === true) {
        setShops(res.data.shops);
      }

      setLoading(false);
    })
    .catch((err) => {
      console.log(err);
      setLoading(false);
    });
};
useEffect(() => {
  fetchTopShops();
}, []);
  return (
    <section className="top-shops-section">
      <div className="top-shops-header">
        <div>
          <h2 className="top-shops-title">Top Shops</h2>
          <p className="top-shops-subtitle">
            Trusted sellers with great reviews
          </p>
        </div>
        <button className="blog-view-all" onClick={() => navigate("/shop")}>
          View All <ArrowRight />
        </button>
      </div>

     <div className="shops-grid">

  {loading ? (
    <p>Loading Shops...</p>
  ) : shops.length > 0 ? (

    shops.map((shop) => (
      <TPshop
        key={shop.id}
          shop={shop}
        
      />
    ))

  ) : (
    <p>No Shops Found</p>
  )}

</div>
    </section>
  );
};

export default TopShops;
